import React, { useEffect, useState, useMemo } from "react";
import { Amplify } from "aws-amplify";
import { generateClient } from "aws-amplify/api";
import awsExports from "./aws-exports";
import { listGlobalTimes } from "./graphql/queries";

Amplify.configure(awsExports);

const FlipUnit = ({ digit, days, showDetails, label, text_below, text_above }) => {

  return (
    <div className="flip-card" style={{
      'display': "inline-block",
      'perspective': "1000px",
      'margin': "0 0.5vw", /* mindre marginal, anpassat för fullskärm */
      'position': "relative",
      'width': days > 0 ? "24vw" : "32vw", /* anpassa bredd för stora siffror */
      'height': days > 0 ? "20vw" : "24vw" /* anpassa höjd */
    }}>
      <div className="front" style={{
        'position': "absolute",
        'width': "100%",
        'height': "100%",
        'lineHeight': days > 0 ? "20vw" : "26vw",
        'fontSize': days > 0 ? "20vw" : "26vw",
        'fontWeight': "bold",
        'background': "#222",
        'color': "#fff",
        'borderRadius': "2vw",
        'backfaceVisibility': "hidden",
        'textAlign': "center"
      }}>
        {digit.toString().padStart(2, "0")}
      </div>

      {showDetails ? <div style={{ 'position': 'absolute','color':'#ccc', 'left': '1vw', 'top': '-4vw' }}>{text_above}</div> : null}
      {showDetails ? <div style={{ 'position': 'absolute','color':'#ccc', 'left': '1vw', 'bottom': '-4vw' }}>{text_below}</div> : null}

      <div style={{ 'position': 'absolute', 'right': '1vw', 'top': '1vw', 'lineHeight': days > 0 ? "1.5vw" : "1vw", 'fontSize': days > 0 ? "1.5vw" : "1vw", 'color': "#fff", }}    > {label}</div>
    </div>
  );
};

const gatherLink = () => {

  return (<div
    style={{
      position: "absolute",
      top: "3vh",
      right: "3vw",
      display: "flex",
      flexDirection: "row",
      justifyContent: "flex-start",
      alignItems: "center",
      zIndex: 1000,
    }}
  >
    {/* redirect user to */}
    <a
      href="https://gather.korven.se"
      target="_blank"
      rel="noopener noreferrer"
      style={
        {
        padding: "clamp(0.4em, 1vw, 0.8em) clamp(0.8em, 3vw, 1.5em)",
        fontSize: "clamp(0.9rem, 1vw, 1.2rem)",
        fontWeight: "600",
        borderRadius: "2em",
        border: "2px solid rgba(255, 255, 255, 0.25)",
        background: "rgba(59, 40, 40, 0.1)",
        color: "#fff",
        backdropFilter: "blur(10px)",
        WebkitBackdropFilter: "blur(10px)",
        boxShadow: "0 0 10px rgba(255, 255, 255, 0.15)",
        cursor: "pointer",
        transition: "all 0.3s ease",
        touchAction: "manipulation",
             }}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = "rgba(255, 255, 255, 0.2)";
        e.currentTarget.style.boxShadow = "0 0 20px rgba(255, 255, 255, 0.3)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = "rgba(255, 255, 255, 0.1)";
        e.currentTarget.style.boxShadow = "0 0 10px rgba(255, 255, 255, 0.15)";
      }}
      onTouchStart={(e) => {
        e.currentTarget.style.background = "rgba(255, 255, 255, 0.25)";
        e.currentTarget.style.boxShadow = "0 0 25px rgba(255, 255, 255, 0.4)";
      }}
      onTouchEnd={(e) => {
        e.currentTarget.style.background = "rgba(255, 255, 255, 0.1)";
        e.currentTarget.style.boxShadow = "0 0 10px rgba(255, 255, 255, 0.15)";
      }}
    >
      Join
    </a>
  </div>
  );
};

function App() {


  const [targetTime, setTargetTime] = useState(null);
  const [diff, setDiff] = useState(0);
  const [showDetails, setShowDetails] = useState(null)

  // Memoize the API client so it only initializes once
  const API = useMemo(() => generateClient({ authMode: "apiKey" }), []);

  // useEffect now only runs once on mount
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await API.graphql({ query: listGlobalTimes });
        const items = res.data.listGlobalTimes.items;
        if (items.length > 0) {
          setTargetTime(new Date(items[0].ts));
        }
      } catch (err) {
        console.error("Error fetching timestamp:", err);
      }
    };

    fetchData();
  }, [API]); // dependency is safe now


  // Countdown interval
  useEffect(() => {
    if (!targetTime) return;

    const updateDiff = () => {
      const now = new Date();
      setDiff(targetTime.getTime() - now.getTime());
    };

    updateDiff();
    const interval = setInterval(updateDiff, 1000);
    return () => clearInterval(interval);
  }, [targetTime]);


  const maptokilometer = (ms) => {
    const value = Math.abs(ms / 1000);
    const initialLength = 600;
    const shrinkStep = 20;
    const initialMax = 600;
    let counter = 0;
    if (value < 0) return 0;

    let intervalStart = 0;
    let intervalLength = initialLength;
    let maxValue = initialMax;

    while (value >= intervalStart + intervalLength && intervalLength > 0) {
      intervalStart += intervalLength;
      intervalLength = Math.max(intervalLength - shrinkStep, 0);
      maxValue = Math.max(maxValue - shrinkStep, 0);

      counter += 1
    }

    if (intervalLength <= 0) return 0;

    return counter;

  }
  // Map to shrinking interval
  const mapToShrinkingInterval = (value) => {

    const initialLength = 600;
    const shrinkStep = 20;
    const initialMax = 600;
    if (value < 0) return 0;

    let intervalStart = 0;
    let intervalLength = initialLength;
    let maxValue = initialMax;

    while (value >= intervalStart + intervalLength && intervalLength > 0) {
      intervalStart += intervalLength;
      intervalLength = Math.max(intervalLength - shrinkStep, 0);
      maxValue = Math.max(maxValue - shrinkStep, 0);
    }


    if (intervalLength <= 0) return 0;

    const relativeValue = intervalLength - (value - intervalStart);
    return Math.min(relativeValue, maxValue);
  };

  // Map to shrinking interval
  const get_interval = (value) => {

    const initialLength = 600;
    const shrinkStep = 20;
    const initialMax = 600;
    if (value < 0) return 0;

    let intervalStart = 0;
    let intervalLength = initialLength;
    let maxValue = initialMax;

    while (value >= intervalStart + intervalLength && intervalLength > 0) {
      intervalStart += intervalLength;
      intervalLength = Math.max(intervalLength - shrinkStep, 0);
      maxValue = Math.max(maxValue - shrinkStep, 0);
    }


    if (intervalLength <= 0) return 0;
    return intervalLength;
  };


  const get_formated_time = (ms) => {
    const absMs = Math.abs(ms);
    const totalSeconds = Math.floor(absMs / 1000);
    const { days, hours, minutes, seconds } = get_time_separated(totalSeconds)
    let string = days > 0 ? `${days.toString().padStart(2, "0")}:` : ''
    return string +
      `${hours.toString().padStart(2, "0")}:` +
      `${minutes.toString().padStart(2, "0")}:` +
      `${seconds.toString().padStart(2, "0")}`;

  }


  const get_time_separated = (input_seconds) => {
    const days = Math.floor(input_seconds / (3600 * 24));
    const hours = Math.floor((input_seconds % (3600 * 24) / 3600));
    const minutes = Math.floor((input_seconds % 3600) / 60);
    const seconds = input_seconds % 60;
    return { days, hours, minutes, seconds };
  }
  const pre_start = (ms) => {
    const totalSeconds = Math.floor(Math.abs(ms) / 1000);

    return get_time_separated(totalSeconds)
  };

  const after_start = (ms) => {
    const totalSeconds = Math.floor(Math.abs(ms) / 1000);
    return get_time_separated(mapToShrinkingInterval(totalSeconds))
  };

  const is_game_on = (ms) => {
    return (ms > 0 || ms < -9300000)
  }

  const get_current_lap_time = (ms) => {

    return get_formated_time(get_interval(Math.abs(Math.floor(ms / 1000))) * 1000)
  }
  const get_lap_completion = (ms, digits) => {

    const past_time = getTimeUnits(diff)
    const all_time = get_interval(Math.abs(Math.floor(ms / 1000)))
    return Number((1 - (past_time.minutes * 60 + past_time.seconds) / all_time) * 100).toFixed(digits)
  }
  const get_km_completed = (ms) => {
    return maptokilometer(diff)
  }

  const show_image = (ms) => {


    if (is_game_on(ms)) { return false}

    if ( getTimeUnits(diff).minutes ===2)
      return true;

    return false
  }

  const getTimeUnits = (ms) => (is_game_on(ms) ? pre_start(ms) : after_start(ms));
  const { days, hours, minutes, seconds } = getTimeUnits(diff);

  return (
    <div>

      {/* Toggle button */}
      <>
   {is_game_on(diff) === false ? (
  <div
    style={{
      position: "absolute",
      top: "3vh",
      left: "3vw",
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      zIndex: 1000,
    }}
  >
    <button
      style={{
        padding: "clamp(0.4em, 1vw, 0.8em) clamp(0.8em, 3vw, 1.5em)",
        fontSize: "clamp(0.9rem, 1vw, 1.2rem)",
        fontWeight: "600",
        borderRadius: "2em",
        border: "2px solid rgba(255, 255, 255, 0.25)",
        background: "rgba(59, 40, 40, 0.1)",
        color: "#fff",
        backdropFilter: "blur(10px)",
        WebkitBackdropFilter: "blur(10px)",
        boxShadow: "0 0 10px rgba(255, 255, 255, 0.15)",
        cursor: "pointer",
        transition: "all 0.3s ease",
        touchAction: "manipulation",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = "rgba(255, 255, 255, 0.2)";
        e.currentTarget.style.boxShadow = "0 0 20px rgba(255, 255, 255, 0.3)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = "rgba(255, 255, 255, 0.1)";
        e.currentTarget.style.boxShadow = "0 0 10px rgba(255, 255, 255, 0.15)";
      }}
      onTouchStart={(e) => {
        e.currentTarget.style.background = "rgba(255, 255, 255, 0.25)";
        e.currentTarget.style.boxShadow = "0 0 25px rgba(255, 255, 255, 0.4)";
      }}
      onTouchEnd={(e) => {
        e.currentTarget.style.background = "rgba(255, 255, 255, 0.1)";
        e.currentTarget.style.boxShadow = "0 0 10px rgba(255, 255, 255, 0.15)";
      }}
      onClick={() => setShowDetails(!showDetails)}
    >
      {showDetails ? "Hide Details" : "Show Details"}
    </button>

    {/* 🔽 Bilden under knappen 🔽 */}
    {show_image(diff) && (
      <img
        src= {showDetails?"/korv_med_klader.png":"/korv_utan_klader.png"} // <-- byt till din egen bildväg, t.ex. "/images/myimage.png"
        alt="Korven Frontyard Logo"
        style={{
          marginTop: "1rem",
          width: "8vw",
          minWidth: "100px",
          borderRadius: "1vw",
          boxShadow: "0 0 20px rgba(255,255,255,0.2)",
        }}
      />
    )}
  </div>
) : (
  ""
)}
      </>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh", // fyller hela viewport
          width: "100vw",
          fontFamily: "sans-serif",
          background: "#111",
          color: "#fff",
        }}
      >
        {targetTime ? (
          <>
            {
                <div style={{ fontSize: days > 0 ? "6vw" : "1vw", marginBottom: "2vh", textAlign: "center",        'fontWeight': "bold",
                'color': "#fff",
        'borderRadius': "2vw",
         }}>
                  {diff > 0 ? "Korven Frontyard Countdown" : null}
                </div>
            }
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {days > 0 ? <FlipUnit digit={days} days={days} label="Days" /> : null}
              {hours > 0 ||days > 0  ? <FlipUnit digit={hours} days={days} label="Hours" /> : null}
              <FlipUnit
                digit={minutes}
                days={days}
                showDetails={showDetails}
                label={"Minutes"}
                text_above={`Total time:${get_formated_time(diff)}`}
                text_below={`Current lap time: ${get_current_lap_time(diff)}`}
              />
              <FlipUnit
                digit={seconds}
                days={days}
                label={"Seconds"}
                showDetails={showDetails}
                text_above={`Kilometers completed: ${get_km_completed(diff)} ${get_lap_completion(diff,1)*10}m`}
                text_below={`Lap completion: ${get_lap_completion(diff,0)}%`}
              />
            </div>
            { (is_game_on(diff)===true || showDetails) && gatherLink({})}

          </>
        ) : (
          <p style={{ fontSize: "5vw" }}>Laddar Korven Frontyard...</p>
        )}
      </div>
    </div>
  );
}

export default App;
